import { useRouter } from 'next/router';
import {
  Select, MenuItem, FormControl, InputLabel,
} from '@mui/material';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import { jobLocationTypes } from 'lib/constants/jobs';
import { JobLocationType } from 'lib/types/jobs';

interface Props {
  selected?: JobLocationType;
}

export const LocationTypeFilter = ({
  selected,
}: Props) => {
  const router = useRouter();
  const allTypes = Object.keys(jobLocationTypes);

  const onChange = (n: string) => {
    if (n === '') {
      updateRouterQuery(router, { locationType: [] });
      return;
    }

    updateRouterQuery(router, { locationType: n });
  };

  const onClose = (): void => {
    // This is a small hack so that the Select blurs when the select menu is closed.
    // See https://stackoverflow.com/questions/65411927/blur-material-ui-select-component-on-the-onchange-event
    setTimeout(() => {
      (document?.activeElement as HTMLInputElement)?.blur();
    }, 0);
  };

  return (
    <FormControl className="w-full" size="small">
      <InputLabel id="locationTypeLabel">Location Type</InputLabel>
      <Select
        className="w-full"
        label="location type"
        labelId="locationTypeLabel"
        id="locationType"
        onClose={onClose}
        onChange={(e) => onChange(e.target.value as string)}
        value={selected}
      >
        <MenuItem value="">All</MenuItem>
        {allTypes.map(
          (key: string) => (
            <MenuItem key={key} value={key}>
              {jobLocationTypes[key as JobLocationType]}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
};
